import GameStepBase from './game_step_base';
import _ from '../../../utils/underscore';
import GameCommonPostMessageHandler from '../post_messages/game_common_post_message_handler';
import DemoGamePostMessageHandler from "../post_messages/demo_game_post_message_handler";

export default class BuildGamePostMessageHandlerGameStep extends GameStepBase {
    static CLASS = 'BuildGamePostMessageHandlerGameStep';

    init(params) {
        super.init(params);

        if(_.isNullOrUndefined(params.isReal)) {
            this.throwError('13',`${this.getClassName()} expects parameter isReal which was not supplied`);
        }

        this._isReal = params.isReal;
    }

    run(gameOptions) {
        let commonPostMessageHandler;
        if(gameOptions.skipShowGame){
            commonPostMessageHandler = DemoGamePostMessageHandler.create({
                serviceFactory: this.serviceFactory,
                isReal: this._isReal
            });
        } else {
            commonPostMessageHandler = GameCommonPostMessageHandler.create({
                serviceFactory: this.serviceFactory,
                isReal: this._isReal
            });
        }


        return Promise.resolve(Object.assign(gameOptions, {
            postMessageHandler: commonPostMessageHandler
        }));
    }
}